import * as React from 'react';

function SvgVerticalAlignBottom(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			height='1em'
			viewBox='0 0 24 24'
			width='1em'
			className='svg-icon'
			{...props}>
			<path d='M0 0h24v24H0V0z' fill='none' />
			<path d='M11 3v10H8l4 4 4-4h-3V3zM4 19h16v2H4z' />
		</svg>
	);
}

export default SvgVerticalAlignBottom;
